import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BudgetComponent } from './components/budget/budget.component';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { DebtsComponent } from './components/debts/debts.component';
import { FamilyFormComponent } from './components/family-form/family-form.component';
import { HealthInsuranceComponent } from './components/health-insurance/health-insurance.component';
import { IncomeTaxComponent } from './components/income-tax/income-tax.component';
import { InssRetirementComponent } from './components/inss-retirement/inss-retirement.component';
import { InsuranceComponent } from './components/insurance/insurance.component';
import { ConsultingModelComponent } from './components/investments/component/consulting-model/consulting-model.component';
import { InvestmentsComponent } from './components/investments/investments.component';
import { JobFormComponent } from './components/job-form/job-form.component';
import { PensionComponent } from './components/pension/pension.component';
import { PropertiesComponent } from './components/properties/properties.component';
import { VehiclesComponent } from './components/vehicles/vehicles.component';
import { setCollectDataAction } from './store/collect-data.actions';
import { getCollectDataSelectors } from './store/collect-data.selectors';
import { ICollectDataState } from './store/collect-data.state';

@Component({
  selector: 'app-collect-data',
  templateUrl: './collect-data.component.html',
  styleUrls: ['./collect-data.component.scss'],
})
export class CollectDataComponent implements OnInit {
  @ViewChild(JobFormComponent) jobForm: JobFormComponent;
  @ViewChild(FamilyFormComponent) familyForm: FamilyFormComponent;
  @ViewChild(IncomeTaxComponent) incomeForm: IncomeTaxComponent;
  @ViewChild(HealthInsuranceComponent)
  healthInsuranceForm: HealthInsuranceComponent;
  @ViewChild(InsuranceComponent) insuranceForm: InsuranceComponent;
  @ViewChild(PensionComponent) pensionForm: PensionComponent;
  @ViewChild(PropertiesComponent) propertiesForm: PropertiesComponent;
  @ViewChild(VehiclesComponent) vehiclesForm: VehiclesComponent;
  @ViewChild(InssRetirementComponent) inssForm: InssRetirementComponent;
  @ViewChild(InvestmentsComponent) investmentsForm: InvestmentsComponent;
  @ViewChild(ConsultingModelComponent) consultingForm: ConsultingModelComponent;
  @ViewChild(BudgetComponent) budgetForm: BudgetComponent;
  @ViewChild(CreditCardComponent) creditCardForm: CreditCardComponent;
  @ViewChild(DebtsComponent) debtsForm: DebtsComponent;

  topicID: number = 1;
  fieldID: number = 1;

  dataState$: Observable<ICollectDataState>;
  dataState: ICollectDataState;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.getState();
  }

  continue() {
    this.fieldID += 1;
    this.updateTopic();
  }

  saveForms() {
    if (this.fieldID === 1) {
      this.jobForm.saveForm();
    }
    if (this.fieldID === 2) {
      this.familyForm.saveForm();
    }

    if (this.fieldID === 3) {
      this.incomeForm.saveForm();
    }
    if (this.fieldID === 4) {
      this.healthInsuranceForm.saveForm();
    }

    if (this.fieldID === 5) {
      this.insuranceForm.saveForm();
    }
    if (this.fieldID === 6) {
      this.pensionForm.saveForm();
    }

    if (this.fieldID === 7) {
      this.propertiesForm.saveForm();
    }
    if (this.fieldID === 8) {
      this.vehiclesForm.saveForm();
    }

    if (this.fieldID === 9) {
      this.inssForm.saveForm();
    }

    if (this.fieldID === 10) {
      this.investmentsForm.saveForm();
    }

    if (this.fieldID === 11) {
      this.consultingForm.saveForm();
    }

    if (this.fieldID === 12) {
      this.continue();
    }

    if (this.fieldID === 13) {
      this.budgetForm.saveForm();
    }
    if (this.fieldID === 14) {
      this.creditCardForm.saveForm();
    }
    if (this.fieldID === 15) {
      this.debtsForm.saveForm();
    }
  }

  updateTopic() {
    if (this.fieldID <= 3) {
      this.topicID = 1;
    } else if (this.fieldID <= 6) {
      this.topicID = 2;
    } else if (this.fieldID <= 12) {
      this.topicID = 3;
    } else if (this.fieldID <= 16) {
      this.topicID = 4;
    }
  }

  back() {
    this.fieldID == 1 ? (this.fieldID = 1) : (this.fieldID -= 1);
    this.updateTopic();
  }

  selectTopic(num: number) {
    this.topicID = num;
    if (num == 1) {
      this.fieldID = 1;
    } else if (num == 2) {
      this.fieldID = 4;
    } else if (num == 3) {
      this.fieldID = 7;
    } else if (num == 4) {
      this.fieldID = 11;
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: ICollectDataState) {
    this.store.dispatch(setCollectDataAction(data));
  }

  getState() {
    this.dataState$ = this.store.select(getCollectDataSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = true;
    this.setState(this.dataState);
  }
}
